export default "__VITE_ASSET__CFTZcG2Q__"